/// <amd-module name="Wiki/ViewCommon/Utils/WikiPermissionsHelper" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssSecurityService } from "VSS/Platform/Security";

import { GitConstants, GitRepositoryPermissions } from "Wiki/Clients/VC/Contracts/Constants";
import { WikiV2 } from "Wiki/Clients/Wiki/Contracts/Wiki";
import { isCodeWiki } from "Wiki/ViewCommon/Utils/WikiHelper";

export function hasWikiRenamePermission(pageContext: IVssPageContext, wiki: WikiV2, isStakeholder: boolean): boolean {
    return (
        !isStakeholder &&
        (isCodeWiki(wiki)
            ? hasWikiContributePermission(pageContext, wiki, isStakeholder)
            : hasPermission(pageContext, wiki.projectId, wiki.repositoryId, GitRepositoryPermissions.RenameRepository))
    );
}

export function hasWikiContributePermission(pageContext: IVssPageContext, wiki: WikiV2, isStakeholder: boolean): boolean {
    return !isStakeholder && hasRepoContributePermission(pageContext, wiki);
}

export function hasWikiManagePermission(pageContext: IVssPageContext, wiki: WikiV2, isStakeholder: boolean): boolean {
    return !isStakeholder && hasPermission(pageContext, wiki.projectId, wiki.repositoryId, GitRepositoryPermissions.ManagePermissions);
}

export function hasWikiCreatePermission(pageContext: IVssPageContext, projectId: string, isStakeholder: boolean): boolean {
    return !isStakeholder && hasPermission(pageContext, projectId, undefined, GitRepositoryPermissions.CreateRepository);
}

export function hasWikiPageCommentsWritePermission(pageContext: IVssPageContext, wiki: WikiV2, isStakeholder: boolean): boolean {
    return isStakeholder || hasRepoContributePermission(pageContext, wiki);
}

/**
 *
 * @param pageContext Checks for git contribute permission at project scope
 * @param projectId
 * @param isStakeholder
 */
export function hasProjectContributePermission(pageContext: IVssPageContext, projectId: string, isStakeholder: boolean): boolean {
    return !isStakeholder && hasPermission(pageContext, projectId, undefined, GitRepositoryPermissions.GenericContribute);
}

export function calculateGitSecuredToken(projectId: string, repositoryId: string | undefined): string {
    const partialProjectToken = projectId + "/";
    const partialRepoToken = !!repositoryId ? repositoryId + "/" : "";

    return GitConstants.SecurableRoot + partialProjectToken + partialRepoToken;
}

function hasRepoContributePermission(pageContext: IVssPageContext, wiki: WikiV2): boolean {
    return hasPermission(pageContext, wiki.projectId, wiki.repositoryId, GitRepositoryPermissions.GenericContribute);
}

function hasPermission(
    pageContext: IVssPageContext,
    projectId: string,
    repositoryId: string | undefined,
    permissionFlag: GitRepositoryPermissions
): boolean {
    const securityService = pageContext.getService<IVssSecurityService>("IVssSecurityService");
    return securityService.hasPermission(GitConstants.GitSecurityNamespaceId, calculateGitSecuredToken(projectId, repositoryId), permissionFlag);
}
